import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetScrapingAggregateStatusRequestModel, GetScrapingAggregateStatusResponseModel } from "@/features/accounts/payment/scraping/services/scrapingaggregate-status-model";

export class ScrapingAggregateStatusApi {
/**
* アグリゲーション状態取得API
*/
    public getAggregateStatus = async (
        param: GetScrapingAggregateStatusRequestModel
    ): Promise<GetScrapingAggregateStatusResponseModel> => {
        // pythonのblueprintでは /aggregate/status
        const path = `/api/scrapingaggregate/status`;

        const res = await ApiClient.instance.get<GetScrapingAggregateStatusResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
